import { PrismaBillingConfigurationDto } from 'app/API';
import { TRatesState } from '../types/TRatesState';

export const defaultRatesState: TRatesState = {
  realTimeRateType: 'FLAT_FEE',
  realTimeRate: '0',
  postProcessingRateType: 'FLAT_FEE',
  postProcessingRate: '0',
  partialUnlockRateType: 'FLAT_FEE',
  partialUnlockRate: '0',
  fullUnlockRateType: 'FLAT_FEE',
  fullUnlockRate: '0',
  fullUnlockChargeType: 'PAY_DIFFERENCE',
  enhancedOnDemandRateType: 'FLAT_FEE',
  enhancedOnDemandRate: '0',
  attorneyConnectFeeRateType: 'FLAT_FEE',
  attorneyConnectFeeRate: '0',
  attorneyInviteFeeRateType: 'FLAT_FEE',
  attorneyInviteFeeRate: '0',
};

export const buildRatesState = (billingConfiguration: PrismaBillingConfigurationDto | undefined): TRatesState => {
  if (!billingConfiguration) {
    return defaultRatesState;
  }
  return {
    realTimeRateType: billingConfiguration.realTimeRateType ?? defaultRatesState.realTimeRateType,
    realTimeRate: String(billingConfiguration.realTimeRate),
    postProcessingRateType: billingConfiguration.postProcessingRateType ?? defaultRatesState.postProcessingRateType,
    postProcessingRate: String(billingConfiguration.postProcessingRate),
    partialUnlockRateType: billingConfiguration.partialUnlockRateType ?? defaultRatesState.partialUnlockRateType,
    partialUnlockRate: String(billingConfiguration.partialUnlockRate),
    fullUnlockRateType: billingConfiguration.fullUnlockRateType ?? defaultRatesState.fullUnlockRateType,
    fullUnlockRate: String(billingConfiguration.fullUnlockRate),
    fullUnlockChargeType: billingConfiguration.fullUnlockChargeType ?? defaultRatesState.fullUnlockChargeType,
    enhancedOnDemandRateType:
      billingConfiguration.enhancedOnDemandRateType ?? defaultRatesState.enhancedOnDemandRateType,
    enhancedOnDemandRate: String(billingConfiguration.enhancedOnDemandRate),
    attorneyConnectFeeRateType:
      billingConfiguration.attorneyConnectFeeRateType ?? defaultRatesState.attorneyConnectFeeRateType,
    attorneyConnectFeeRate: String(billingConfiguration.attorneyConnectFeeRate),
    attorneyInviteFeeRateType:
      billingConfiguration.attorneyInviteFeeRateType ?? defaultRatesState.attorneyInviteFeeRateType,
    attorneyInviteFeeRate: String(billingConfiguration.attorneyInviteFeeRate),
  };
};
